// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { translateFromPresentation } from "@sequentech/ui-core";
import { useTranslation } from "react-i18next";
var isPlainObject = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
export function useAliasRenderer() {
    var i18n = useTranslation().i18n;
    var aliasRenderer = function (item, defaultLang) {
        var t = function (x) {
            return translateFromPresentation(x, "alias", i18n.language) ||
                translateFromPresentation(x, "name", i18n.language) ||
                (defaultLang
                    ? translateFromPresentation(x, "alias", defaultLang) ||
                        translateFromPresentation(x, "name", defaultLang)
                    : undefined) ||
                translateFromPresentation(x, "alias", "en") ||
                translateFromPresentation(x, "name", "en") ||
                "-";
        };
        if (item == null)
            return "-";
        if (isPlainObject(item)) {
            return t(item);
        }
        var s = String(item).trim();
        if (!s)
            return "-";
        if (s.startsWith("{")) {
            try {
                return t(JSON.parse(s));
            }
            catch (_a) {
                return "-";
            }
        }
        return "-";
    };
    return aliasRenderer;
}
